import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllMedicaoUseCase } from "../../../presentation/useCases/read/get_all_medicao_use_case";
import { MedicaoTerceirizacaoFilter } from "../../models/medicao_terceirizacao_filter";
import { MedicaoTerceirizacaoLista } from "../../models/medicao_terceirizacao_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


// GetAllMedicaoUseCase


export class GetAllMedicaoUseCase
  extends BasePaginatedUseCase<MedicaoTerceirizacaoLista>
  implements IGetAllMedicaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemMedicao(
    filter: MedicaoTerceirizacaoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemMedicao(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
